import * as z from "zod/v4";

export const subscriptionsModeAllowed = {
  name: "subscriptionsModeAllowed" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    allowed: z.boolean(),
    canDisable: z.boolean(),
    canDisableReason: z.string().optional(),
  }),
};
